import { getRoot, types } from 'mobx-state-tree'
import { MSTGQLRef } from 'mst-gql'

import { IMAGES_DOMAIN } from '../constants'
import { LocationModel } from './LocationModel'
import { PartnerTagModel } from './PartnerTagModel'
import { ProviderModelBase } from './ProviderModel.base'

const ProviderLocationDetails = types
  .model('ProviderLocationDetails', {
    id: types.identifier,
    acceptingNewPatients: types.maybeNull(types.boolean),
    telehealthAvailable: types.maybeNull(types.boolean),
    location: types.maybeNull(MSTGQLRef(types.late(() => LocationModel))),
    partnerTags: types.maybeNull(
      types.array(MSTGQLRef(types.late(() => PartnerTagModel)))
    ),
  })
  .views(self => ({
    get store() {
      return getRoot(self)
    },
  }))

/* A graphql query fragment builders for ProviderModel */
export {
  selectFromProvider,
  providerModelPrimitives,
  ProviderModelSelector,
} from './ProviderModel.base'

/**
 * ProviderModel
 *
 * A Provider
 */
export const ProviderModel = ProviderModelBase.props({
  activeAccordion: false,
  credentials: types.maybeNull(types.string),
  npiNumber: types.maybeNull(types.string),
  providerLocations: types.maybeNull(types.array(ProviderLocationDetails)),
})
  .views(self => ({
    get displayName() {
      const name = self.name || ''
      const credentials = self.credentials?.trim()
      return credentials && !name.endsWith(credentials)
        ? `${name}, ${credentials}`
        : name
    },
    get specialtyList() {
      return self.specialties.map(specialty => specialty.name).join(', ')
    },
    get photoUrl() {
      if (self.photoS3Key) {
        return `${IMAGES_DOMAIN}/fit-in/128x128/${self.photoS3Key}`
      }
      return ''
    },
    get formattedLanguagesSpoken() {
      if (self.languagesSpoken) {
        return self.languagesSpoken.join(', ')
      }
      return ''
    },
    get rank() {
      if (self.partnerTier) {
        return self.partnerTier.rank
      }
      /**
       * Artificial rank to push unranked providers down in the sort list
       */
      return 1000
    },
  }))
  .actions(self => ({
    toggleAccordion(active) {
      self.activeAccordion = active || !self.activeAccordion
    },
  }))
